function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M850.861,1848l3.557.158c.036.7.1,1.329.1,1.962.006,8.674.034,17.347-.025,26.021-.01,1.427.377,1.871,1.833,1.844,4.745-.09,9.492-.034,14.238-.033,2.981,0,3.063.1,2.458,3.451H850.861Z",
  transform: "translate(-850.861 -1839.4)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M883.878,1881.842H876.9v-41.95l21.787,28.837.373-.159v-19.94h7.027v41.262l-21.83-28.869-.38.107Z",
  transform: "translate(-849.508 -1839.893)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M912.717,1881.213v-33.02H937.5v6.305H919.792c0,2.168-.06,4.171.068,6.161.018.283.941.718,1.451.726,4.037.06,8.075.033,12.113.033h1.913v6.341H919.881v7.057h17.788v6.4Z",
  transform: "translate(-847.664 -1839.391)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M946.617,1881.289h-3.493v-33.21c1.93,0,3.823-.03,5.715.006,3.814.072,7.654-.074,11.435.332,6.6.708,10.366,6.475,8.5,12.605-1.012,3.333-3.478,5.158-6.639,6.216-.557.186-1.127.333-1.9.561,1.739,2.332,3.391,4.552,5.048,6.769,1.621,2.17,3.248,4.338,5.069,6.77a33.468,33.468,0,0,1-3.822-.046,2.393,2.393,0,0,1-1.357-.961q-4.053-5.347-8.014-10.761a2.594,2.594,0,0,0-2.425-1.269c-2.178.093-4.366.086-6.546.005-1.223-.046-1.617.382-1.592,1.593.065,3.163.021,6.329.021,9.493Zm.108-16.257c4.055,0,7.919.037,11.781-.028a7.929,7.929,0,0,0,2.526-.608,6.525,6.525,0,0,0,4.521-6.655,5.813,5.813,0,0,0-5.251-5.793c-4.451-.517-8.971-.435-13.577-.615Z",
  transform: "translate(-846.078 -1839.396)",
  fill: "#fff"
});

function SvgLnerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lner-logo",
    width: 124.273,
    height: 50,
    viewBox: "0 0 124.273 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnerLogo);
export default __webpack_public_path__ + "static/media/lner-logo.076db00c.svg";
export { ForwardRef as ReactComponent };